<template>
  <div
    class="view-more-button"
    :class="isDisabled ? 'disabled' : 'active'"
    @click="$emit('buttonClick')"
  >
    Explore More
    <img class="arrow-img" src="@/assets/icon/right-arrow-grey.svg" />
  </div>
</template>

<script>
export default {
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.view-more-button {
  cursor: pointer;
  display: flex;
  align-items: center;
  font-family: Inter-SemiBold;
  font-size: 16px;
  color: #828c9f;
  .arrow-img {
    margin-left: 8px;
  }
  &.active {
    &:hover {
      text-decoration: underline;
    }
  }
  &.disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
}
</style>
